import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faCheck, faCircleCheck, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import styles from "./FeedbackInboxModal.module.css";
import ModalHeader from "./ModalHeader";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";

function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

function fmtTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
}

export default function FeedbackInboxModal({ open, onClose, feedbacks = [], onMarkRead }) {
  useBodyScrollLock();
  const [marked, setMarked] = useState(new Set());

  if (!open) return null;

  function markOne(id) {
    setMarked(prev => new Set([...prev, id]));
    onMarkRead([id]);
  }

  function markAll() {
    const ids = feedbacks.map(f => f.id);
    setMarked(new Set(ids));
    onMarkRead(ids);
  }

  const visible = feedbacks.filter(f => !marked.has(f.id));

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <ModalHeader onClose={onClose} />
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <span className={styles.headerIcon}><FontAwesomeIcon icon={faCommentDots} /></span>
            <h2 className={styles.headerTitle}>Feedback do professor</h2>
            {visible.length > 0 && <span className={styles.badge}>{visible.length}</span>}
          </div>
          <div className={styles.headerRight}>
            {visible.length > 1 && (
              <button className={styles.markAllBtn} onClick={markAll}>
                Marcar tudo como lido
              </button>
            )}
          </div>
        </div>

        <div className={styles.body}>
          {visible.length === 0 ? (
            <div className={styles.empty}>
              <span className={styles.emptyIcon}><FontAwesomeIcon icon={faCircleCheck} /></span>
              <div>Nenhuma mensagem não lida</div>
            </div>
          ) : (
            <div className={styles.list}>
              {visible.map(fb => {
                const isSystem = fb.source === "system";
                return (
                  <div key={fb.id} className={isSystem ? styles.cardSystem : styles.card}>
                    <div className={styles.cardTop}>
                      <div className={styles.professorRow}>
                        {isSystem ? (
                          <div className={styles.systemAvatar}><FontAwesomeIcon icon={faTriangleExclamation} /></div>
                        ) : (
                          <div className={styles.profAvatar}>
                            {(fb.professor_name || "P")[0].toUpperCase()}
                          </div>
                        )}
                        <div>
                          <div className={isSystem ? styles.systemName : styles.profName}>
                            {isSystem ? "TreinoNexo" : fb.professor_name}
                            {isSystem && <span className={styles.systemBadge}>Automático</span>}
                          </div>
                          <div className={styles.cardDate}>
                            {fmtDate(fb.created_at)} · {fmtTime(fb.created_at)}
                          </div>
                        </div>
                      </div>
                      <button
                        className={styles.readBtn}
                        onClick={() => markOne(fb.id)}
                        title="Marcar como lido"
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    </div>
                    <div className={styles.comment}>{fb.comment}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
